'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 *  Piece of logic to add the class 'scroll' to the body if the page is
 *  scrolled. Only imported and used once in the main.ts
 */
function addIsScrolledListener() {
    var el = document.getElementsByTagName('body')[0];
    window.onscroll = function () {
        if (window.scrollY >= 5) {
            if (!el.classList.contains('is-scrolled')) {
                el.classList.add('is-scrolled');
            }
        }
        else if (window.scrollY < 5) {
            if (el.classList.contains('is-scrolled')) {
                el.classList.remove('is-scrolled');
            }
        }
    };
}

exports.default = addIsScrolledListener;
//# sourceMappingURL=is_scrolled.js.map
